__turbopack_context__.v({
  "desktopGrid": "EventsGrid-module-scss-module__Yyvwzq__desktopGrid",
  "loadMoreWrapper": "EventsGrid-module-scss-module__Yyvwzq__loadMoreWrapper",
  "mobileList": "EventsGrid-module-scss-module__Yyvwzq__mobileList",
});
